import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VirtualTimeScheduler } from 'rxjs';
import { CallModel } from 'src/app/shared/models/calllog.model';
import { ClientModel } from 'src/app/shared/models/client.model';
import { IssueDetailModel, IssueFileModel, IssueModel } from 'src/app/shared/models/issue.model';
import { UserModel } from 'src/app/shared/models/user.model';
import { IssueService } from 'src/app/shared/services/issue.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-issue-detail-container',
  templateUrl: './issue-detail-container.component.html',
  styleUrls: ['./issue-detail-container.component.css']
})
export class IssueDetailContainerComponent implements OnInit {
 
  @Input() issue : IssueDetailModel;
  @Input() call : CallModel;
  @Input() users : UserModel [];
  @Output() onGoBack: EventEmitter<any> = new EventEmitter<any>();
  isEdit : boolean;

  selectedId : string;
  files : IssueFileModel []


  constructor( 
    private aroute : ActivatedRoute, 
    private service : IssueService,
    private userservice : UserService ) { }

  ngOnInit() {
    this.aroute.queryParams.subscribe(params => {
      this.selectedId = params['id'];
      if(this.selectedId != null)
      {
          this.refreshData();
        }
        else{
          if(this.issue && this.issue.issueId)
          {
            this.service.getIssueFileList(this.issue.issueId).subscribe(
              res=>{
                this.files = res as IssueFileModel[];
              },
              err=>{}
            );
          }
        }
    });

  

  }

  refreshData()
  {
    var id = this.selectedId;
    if(this.issue) id = this.issue.issueId;

    this.service.getDetailData(id).subscribe(
      res=>{
        this.issue = res as IssueDetailModel;
      //  this.service.populateForm(this.issue);

        var item1 =  this.users.filter(x => x.id == this.issue.createBy);
        if(item1 != null && item1.length > 0)
            this.issue.createByUser = item1[0];

        var item2 =  this.users.filter(x => x.id == this.issue.closeBy);
          if(item2 != null && item2.length > 0)
              this.issue.closeByUser = item2[0];
      },
      err=>{}
      );

      this.service.getIssueFileList(id).subscribe(
        res=>{
          this.files = res as IssueFileModel[];
        },
        err=>{}
      );
  
  }
  
  afterChangeToEdit(data : any)
  {
    this.isEdit = true;
  }

  afterChangeToDetail(data : any)
  {
    console.log("afterChangeToDetail : " + data);
    if(data)
    {
      this.selectedId = data.issueId;
    }
    this.refreshData();
  
    this.isEdit = false;
  }

  afterUpdate(data : any){
    console.log("afterUpdate");
    if(data)
    {
      if(this.call)
      {
        this.refreshData();
      }
      else{
        this.onGoBack.emit(); 
      }
    }
    else{
      this.refreshData();
    }
  }

  onGoList()
  {
    this.onGoBack.emit(); 
  }
}
